/**
 * 휴게시간 문자열 → 시간/분 변환 (문서 8.1·8.4)
 * '30분'→0.5, '1시간'→1.0, '1시간 30분'→1.5, '2시간'→2.0, 그 외 0
 */

const BREAK_MAP: Record<string, number> = {
  '0분': 0,
  '30분': 0.5,
  '1시간': 1.0,
  '1시간 30분': 1.5,
  '2시간': 2.0,
  '2시간 30분': 2.5,
  '3시간': 3.0,
  '3시간 30분': 3.5,
  '4시간': 4.0,
  '4시간 30분': 4.5,
  '5시간': 5.0,
};

/**
 * 휴게시간 문자열을 시간 단위(숫자)로 반환. 문서와 무관한 값은 0.
 */
export function breakTimeStringToHours(s: string | null | undefined): number {
  if (s == null || s === '') return 0;
  const v = BREAK_MAP[s];
  return v !== undefined ? v : 0;
}

/**
 * 휴게시간 문자열을 분 단위로 반환. round(breakHours * 60)
 */
export function breakTimeStringToMinutes(s: string | null | undefined): number {
  return Math.round(breakTimeStringToHours(s) * 60);
}
